import React, { createContext, PropsWithChildren, useCallback, useContext, useState } from "react";

interface LoginDialogState {
    open: boolean;
    redirectAfterLogin?: string;
}

interface LoginDialogActions {
    openLogin: (redirectTo?: string) => void;
    closeLogin: () => void;
}

interface LoginDialogContextValue {
    state: LoginDialogState;
    actions: LoginDialogActions;
}

const LoginDialogContext = createContext<LoginDialogContextValue>({
    state: { open: false },
    actions: {
        openLogin: () => {},
        closeLogin: () => {},
    },
});

const Provider: React.FC<PropsWithChildren> = ({ children }) => {
    const [open, setOpen] = useState(false);
    const [redirectAfterLogin, setRedirectAfterLogin] = useState<string | undefined>();

    const openLogin = useCallback((redirectTo?: string) => {
        setRedirectAfterLogin(redirectTo);
        setOpen(true);
    }, []);

    const closeLogin = useCallback(() => {
        setOpen(false);
        setRedirectAfterLogin(undefined);
    }, []);

    return (
        <LoginDialogContext.Provider value={{ state: { open, redirectAfterLogin }, actions: { openLogin, closeLogin } }}>
            {children}
        </LoginDialogContext.Provider>
    );
};

const useLoginDialog = () => useContext(LoginDialogContext);

export { LoginDialogContext as Context, Provider, useLoginDialog };
